import axios from 'axios'
import store from '../vuex/index'

import {domainParser, subDomainParser} from './UrlParser'

let defaultConfig = {
  version: 'v1',
  secure: false,
}

/**
 * Generate Axios Instance with automatic baseUrl resolution.
 * Also enable withCredentials to allow cookies to be sent for Auth.
 *
 * @param subdomain
 * @param version
 * @param secure
 * @returns {AxiosInstance}
 * @constructor
 */
 let ApiFactory = (subdomain, version = 'v1', secure = false) => {

  let protocol = window.location.protocol

  // Force https manually, otherwise use default
  if(secure) {
    protocol = 'https:'
  }

  let api = axios.create({
    baseURL: protocol + '//' + subdomain + domainParser() + '/api/' + version + '/',
    withCredentials: true,
  })

  api.interceptors.response.use((response) => response, (error) => {

    if (_.get(error.response, 'status') !== 422) {
      store.commit('baseAddNotification', {
        title: 'Error!',
        text: error.response.data.message,
        type: 'error',
        timeout: false,
      })
    }

    throw error
  })

  return api
}

const Api = {
  install(Vue2, options) {

    let config = Object.assign(defaultConfig, options)

    Vue2.prototype.$api = {
      public(version = config.version) {
        return ApiFactory('app', version, config.secure)
      },
      superAdmin(version = config.version) {
        return ApiFactory('system', version, config.secure)
      },
      active(version = config.version) {
        return ApiFactory(subDomainParser(), version, config.secure)
      },
    }
  },
}

export default Api